import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PathFactory from './PathFactory';
export function usePathFactory() {
  const {
    i18n
  } = useTranslation();
  // let pathFactory = new PathFactory(i18n);
  const pathFactory = useMemo(() => new PathFactory(i18n), [i18n]);
  return pathFactory;
}